import { absolutePath } from "./absolutePath";

const onboarding = {
  get: () => absolutePath("admin/onboarding_settings"),
  upsert: () => absolutePath("admin/onboarding_settings/upsert"),
};

// TODO: Remove after feature flag welcome_page_home_tabs_enabled is removed
const welcomeSpaces = {
  get: () => absolutePath("admin/welcome_spaces"),
  put: () => absolutePath("admin/welcome_spaces"),
};

const welcomeData = {
  get: () => absolutePath("admin/welcome_data"),
  put: () => absolutePath("admin/welcome_data"),
};

const designConfig = {
  get: () => absolutePath("admin/branded_mobile_app"),
  put: () => absolutePath("admin/branded_mobile_app"),
};

const brandedAppsBuilderPages = {
  get: <T extends object>(params: T) =>
    absolutePath("admin/branded_mobile_app_builders", params),
  upsert: () => absolutePath("admin/branded_mobile_app_builders/upsert"),
};

const builderSettings = {
  get: () => absolutePath("admin/branded_mobile_app_builder_settings"),
  upsert: () =>
    absolutePath("admin/branded_mobile_app_builder_settings/upsert"),
};

const navigation = {
  get: () => absolutePath("admin/branded_mobile_app_navigation"),
  update: () => absolutePath("admin/branded_mobile_app_navigation"),
};

const previewSnapshots = {
  create: () => absolutePath("admin/branded_mobile_app_preview_snapshots"),
};

export const brandedAppsBuilderUI = {
  builderSettings,
  onboarding,
  welcomeData,
  welcomeSpaces,
  designConfig,
  brandedAppsBuilderPages,
  navigation,
  previewSnapshots,
};
